import { cn } from '@/lib/client'
import { RotateCw, ShieldCheckIcon } from 'lucide-react'

export default function HeaderCheckout({
  contrast = false,
}: {
  contrast?: boolean
}) {
  return (
    <header>
      <nav
        className={cn(
          'border-b w-full z-20 top-0 left-0 text-sm',
          contrast ? 'bg-zinc-900 h-60' : 'bg-zinc-50',
        )}
      >
        <div
          className="w-full h-1 bg-gradient-to-r from-zinc-500/20 to-zinc-500/60 absolute"
          style={{ display: 'none' }}
        >
          <div
            id="loading-bar"
            className="h-full bg-gradient-to-r from-amber-500 to-orange-500 rounded-r-xl transition-all ease-in-out duration-300"
            style={{ width: 0 }}
          />
        </div>
        <RotateCw
          id="loading-spinner"
          className="loading h-5 w-5 stroke-orange-400 animate-spin absolute top-8 sm:top-2 xl:top-8 right-5"
          style={{ display: 'none' }}
        />
        <div className="flex flex-wrap items-center justify-between mx-auto max-w-7xl px-4 py-4 sm:px-4 lg:px-6 h-20">
          <img
            loading="eager"
            src={
              contrast ? '/images/logo-white.webp' : '/images/logo-color.webp'
            }
            height={30}
            width={120}
            alt="Logo do Direção Concursos"
          />
          <div className="hidden w-full sm:block sm:w-auto" id="navbar-default">
            <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 md:flex-row md:space-x-2 md:mt-0">
              <li>
                <div className="flex text-xs text-zinc-400 justify-center text-center items-center">
                  <ShieldCheckIcon
                    className={cn(
                      'mr-2 h-6 w-6',
                      !contrast && 'text-emerald-500',
                    )}
                  />
                  <span>AMBIENTE SEGURO</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}
